import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { CustomRulesDataProviderFactory } from '../factory/CustomRulesDataProviderFactory';
import { CustomRulesBaseDataProvider } from '../dataProvider/CustomRulesBaseDataProvider';
import { CustomRulesWebComponentData, CustomRulesWebComponentSchema } from '../types';

export class CustomRulesRepository extends BaseWebComponentRepository {
  public dataProviderFactory: CustomRulesDataProviderFactory;
  public dataProvider: CustomRulesBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new CustomRulesDataProviderFactory(),
    });
  }

  async getDataForView(): Promise<CustomRulesWebComponentData> {
    return this.dataProvider.getDataForView();
  }
}
